export interface DeviceQrCredentials {
  serial: string;
  pin: string;
}

/**
 * Extracts the device serial and PIN out of a scanned QR code.
 *
 * Two formats are in the field:
 *  - query style, recognised by containing "serial", e.g.
 *    "https://<host>/device-registration-qr?serial=283B96120D94&pin=4471"
 *    Splitting on "=" and "&" puts the serial third-from-last and the PIN last.
 *  - path style, e.g. "https://<host>/x/y/283B96120D94/4471"
 *    where the serial and PIN sit at path segments 4 and 5.
 *
 * Kept as a pure function so both the authenticated add-device screen and the
 * public registration flow (CM-168) parse codes identically.
 */
export const parseDeviceQrCode = (qrCode: string): DeviceQrCredentials => {
  const isQueryFormat = qrCode.includes("serial");
  const parts = isQueryFormat ? qrCode.split(/[=&]+/) : qrCode.split("/");

  if (isQueryFormat) {
    const lastIndex = parts.length - 1;
    return {
      serial: parts[lastIndex - 2],
      pin: parts[lastIndex]
    };
  }

  return {
    serial: parts[4],
    pin: parts[5]
  };
};
